export const createDisplayText = (
  label: string,
  checkedItems: Array<{ label: string; checked: boolean }>
) => {
  if (checkedItems.length === 0) return label
  if (checkedItems.length === 1) return checkedItems[0].label
  return `${label} (${checkedItems.length})`
}
